import CitySEOHead from "@/components/feature/CitySEOHead";
import AlbanyHeroSection from "./components/HeroSection";
import AlbanyStickyNav from "./components/StickyNav";
import AlbanyProcessingTimeSection from "./components/ProcessingTimeSection";
import AlbanyServicesSection from "./components/ServicesSection";
import AlbanyLocalAreaSection from "./components/LocalAreaSection";
import AlbanyTestimonialsSection from "./components/TestimonialsSection";
import AlbanyAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AlbanyComparisonSection from "./components/ComparisonSection";
import AlbanyMistakesSection from "./components/MistakesSection";
import AlbanyHowItWorksSection from "./components/HowItWorksSection";
import AlbanyFAQSection, { faqs } from "./components/FAQSection";
import AlbanyHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AlbanyFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const albanyFaqs = faqs as { q: string; a: string }[];

const albanyServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function AlbanyPage() {
  return (
    <>
      <CitySEOHead
        city="Albany"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/albany-ga"
        title="Emergency Passport Albany, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Albany, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving southwest Georgia travelers. Get your emergency passport fast!"
        geoPlacename="Albany, Georgia"
        geoPosition="31.5785;-84.1557"
        faqs={albanyFaqs}
        servicesSchema={albanyServices}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Albany passport, same day passport Georgia, fast passport Albany GA"
      />
      <div className="font-sans">
        <AlbanyHeroSection />
        <AlbanyStickyNav />
        <AlbanyProcessingTimeSection />
        <AlbanyLocalAreaSection />
        <AlbanyServicesSection />
        <AlbanyTestimonialsSection />
        <AlbanyAcceptanceFacilitiesSection />
        <AlbanyComparisonSection />
        <AlbanyMistakesSection />
        <AlbanyHowItWorksSection />
        <AlbanyFAQSection />
        <AlbanyHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/albany-ga" state="GA" />
        <AlbanyFinalCTA />
      </div>
    </>
  );
}